var _g;
import * as React from "react";
var SvgDevopsCloudHexagon = function SvgDevopsCloudHexagon(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#devops-cloud-hexagon_svg__paint0_linear_12728_15226)",
    strokeMiterlimit: 10,
    d: "M48.847 49.487h8.461c1.757 0 3.495-.362 5.103-1.065a12.65 12.65 0 0 0 4.237-3.015 12.5 12.5 0 0 0 2.65-4.454 12.45 12.45 0 0 0-.912-10.08 12.6 12.6 0 0 0-3.407-3.914 12.7 12.7 0 0 0-4.71-2.22 12.8 12.8 0 0 0-5.214-.146 17.8 17.8 0 0 0-6.966-7.945 18.02 18.02 0 0 0-10.279-2.636 18 18 0 0 0-9.977 3.599 17.76 17.76 0 0 0-6.168 8.568 6.6 6.6 0 0 0-4.218.792 6.5 6.5 0 0 0-2.815 3.214 9.9 9.9 0 0 0-4.046.105 9.85 9.85 0 0 0-3.66 1.716 9.8 9.8 0 0 0-2.65 3.035 9.67 9.67 0 0 0-.715 7.823 9.7 9.7 0 0 0 2.056 3.458 9.8 9.8 0 0 0 3.29 2.34 9.9 9.9 0 0 0 3.961.825h13.877",
    transform: "translate(27 23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#devops-cloud-hexagon_svg__paint1_linear_12728_15226)",
    strokeLinejoin: "round",
    d: "m32.438 62.047 2.552 3.535",
    transform: "translate(27 23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#devops-cloud-hexagon_svg__paint2_linear_12728_15226)",
    strokeLinejoin: "round",
    d: "m37.545 62.047-2.553 3.535V44.403",
    transform: "translate(27 23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#devops-cloud-hexagon_svg__paint3_linear_12728_15226)",
    strokeLinejoin: "round",
    d: "m44.506 35.847-2.553-3.535",
    transform: "translate(27 23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#devops-cloud-hexagon_svg__paint4_linear_12728_15226)",
    strokeLinejoin: "round",
    d: "m39.39 35.847 2.553-3.535v21.179",
    transform: "translate(27 23)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops-cloud-hexagon_svg__paint0_linear_12728_15226",
    x1: 36.505,
    x2: 36.505,
    y1: 13.992,
    y2: 49.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD7B2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops-cloud-hexagon_svg__paint1_linear_12728_15226",
    x1: 33.714,
    x2: 33.714,
    y1: 62.047,
    y2: 65.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD7B2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops-cloud-hexagon_svg__paint2_linear_12728_15226",
    x1: 36.269,
    x2: 36.269,
    y1: 44.403,
    y2: 65.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD7B2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops-cloud-hexagon_svg__paint3_linear_12728_15226",
    x1: 43.229,
    x2: 43.229,
    y1: 32.312,
    y2: 35.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD7B2",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops-cloud-hexagon_svg__paint4_linear_12728_15226",
    x1: 40.667,
    x2: 40.667,
    y1: 32.312,
    y2: 53.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD7B2",
    stopOpacity: 0.3
  })))));
};
export default SvgDevopsCloudHexagon;